module.exports = __webpack_public_path__ + "static/media/Commuter-Hub_1920x1080@2x.26ebc2e9.png";